import { IonicConfig as IonicCoreConfig } from "@ionic/core";

export const IonicConfig: IonicCoreConfig = {
    mode: 'md',
    spinner: 'crescent',
}